import { PROFILE_DETAILS } from './types.js';
const currentUserDetails = ({ name, role, email, org, phoneNo, isAccountSetUp, roleType }, state) => {
  const newCurrentUserDetails = {
    ...state,
    name,
    role,
    email,
    org,
    phoneNo,
    isAccountSetUp: isAccountSetUp ? isAccountSetUp : false,
    roleType,
  };
  return {
    ...newCurrentUserDetails,
  };
};

export default (state, action) => {
  switch (action.type) {
    case PROFILE_DETAILS:
      return currentUserDetails(action.payload, state);
    default:
      return state;
  }
};
